import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AssetsListPage from './AssetsListPage';

export default function AssetsRoutes() {
  return (
    <Routes>
      <Route index element={<AssetsListPage />} />
    </Routes>
  );
}
